import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const InstitutionHeader = ({ institution }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-start gap-6">
        {/* Logo and Basic Info */}
        <div className="flex items-start gap-4">
          <div className="w-20 h-20 bg-muted rounded-lg overflow-hidden flex-shrink-0">
            <Image 
              src={institution?.logo} 
              alt={`Logo ${institution?.name}`}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl lg:text-3xl font-heading font-bold text-foreground mb-2">
              {institution?.name}
            </h1>
            <div className="flex items-center gap-2 text-muted-foreground mb-2">
              <Icon name="MapPin" size={16} />
              <span className="text-sm">{institution?.location}</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Icon name="Globe" size={16} />
              <span className="text-sm">{institution?.type}</span>
            </div>
          </div>
        </div>

        {/* Key Statistics */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:min-w-0 lg:flex-shrink-0">
          <div className="text-center p-3 bg-muted rounded-lg">
            <div className="text-lg font-semibold text-primary">{institution?.studentCount}</div>
            <div className="text-xs text-muted-foreground">Étudiants</div>
          </div>
          <div className="text-center p-3 bg-muted rounded-lg">
            <div className="text-lg font-semibold text-secondary">{institution?.establishedYear}</div>
            <div className="text-xs text-muted-foreground">Fondée en</div>
          </div>
          <div className="text-center p-3 bg-muted rounded-lg">
            <div className="text-lg font-semibold text-accent">{institution?.programCount}</div>
            <div className="text-xs text-muted-foreground">Programmes</div>
          </div>
          <div className="text-center p-3 bg-muted rounded-lg">
            <div className="text-lg font-semibold text-success">{institution?.employmentRate}%</div>
            <div className="text-xs text-muted-foreground">Employabilité</div>
          </div>
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex flex-wrap gap-3 mt-6 pt-6 border-t border-border">
        <button className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth">
          <Icon name="Heart" size={16} />
          <span className="text-sm font-medium">Ajouter aux favoris</span>
        </button>
        <button className="flex items-center gap-2 px-4 py-2 bg-secondary text-secondary-foreground rounded-lg hover:bg-secondary/90 transition-smooth">
          <Icon name="ExternalLink" size={16} />
          <span className="text-sm font-medium">Site officiel</span>
        </button>
        <button className="flex items-center gap-2 px-4 py-2 border border-border rounded-lg hover:bg-muted transition-smooth">
          <Icon name="Share2" size={16} />
          <span className="text-sm font-medium">Partager</span>
        </button>
        <button className="flex items-center gap-2 px-4 py-2 border border-border rounded-lg hover:bg-muted transition-smooth">
          <Icon name="Download" size={16} />
          <span className="text-sm font-medium">Brochure PDF</span>
        </button>
      </div>
    </div>
  );
};

export default InstitutionHeader;